import { ITag } from "~/types/types";

export default function hidePodcastTag<T extends Record<"tags", Pick<ITag, "name">[]>>(object: T): T {
  return {
    ...object,
    tags: object.tags.filter((candidate) => {
      return candidate.name !== "Podcast";
    }),
  };
}
